/** ************************************************************
 *
 * Progress Circle 1.1.0
 * Updated support for bootstrap
 *
 ************************************************************* */

(function ($) {
    const jqueryFn = $.fn;
    let ProgressCircle = function (element, options) {
        let settings = $.extend({}, $.fn.progressCircle.defaults, options);
        let thicknessConstant = 0.02;
        let nRadians = 0;

        computePercent();
        setThickness();

        let border = `${settings.thickness * thicknessConstant}em`;
        let offset = `${1 - thicknessConstant * settings.thickness * 2}em`;
        let circle = $(element);
        let progCirc = circle.find('.prog-circle');
        let circleDiv = progCirc.find('.bar');
        let circleSpan = progCirc.children('.percenttext');
        let circleFill = progCirc.find('.fill');
        let circleSlice = progCirc.find('.slice');

        if (settings.nPercent === 0) {
            circleSlice.hide();
        } else {
            resetCircle();
            transformCircle(nRadians, circleDiv);
        }
        setBorderThickness();
        updatePercentage();
        setCircleSize();

        function computePercent() {
            if (settings.nPercent > 100 || settings.nPercent < 0) {
                settings.nPercent = 0;
            }
            nRadians = (360 * settings.nPercent) / 100;
        }

        function setThickness() {
            if (settings.thickness > 20) {
                settings.thickness = 10;
            } else if (settings.thickness < 1) {
                settings.thickness = 1;
            } else {
                settings.thickness = Math.round(settings.thickness);
            }
        }

        function setCircleSize() {
            progCirc.css('font-size', `${settings.circleSize}px`);
        }

        function transformCircle(nDegs, cDiv) {
            let rotate = `rotate(${nDegs}deg)`;
            cDiv.css({
                '-webkit-transform': rotate,
                '-moz-transform': rotate,
                '-ms-transform': rotate,
                '-o-transform': rotate,
                transform: rotate,
            });
            if (nDegs > 180) {
                transformCircle(180, circleFill);
                circleSlice.addClass(' clipauto ');
            }
        }

        function setBorderThickness() {
            progCirc.find(' .slice > div ').css({
                'border-width': border,
                width: offset,
                height: offset,
            });
            if (settings.barOverride) {
                progCirc.find(' .slice > div.bar ').css({
                    width: '1em',
                    height: '1em',
                });
            }
            progCirc.find('.after').css({
                top: border,
                left: border,
                width: offset,
                height: offset,
            });
        }

        function resetCircle() {
            circleSlice.show();
            circleSpan.text('');
            circleSlice.removeClass('clipauto');
            transformCircle(20, circleDiv);
            transformCircle(20, circleFill);
            return this;
        }

        function updatePercentage() {
            if (settings.showPercentText) {
                circleSpan.text(`${settings.nPercent}%`);
            }
        }
    };

    jqueryFn.progressCircle = function (options) {
        return this.each(function (_key, _value) {
            let element = $(this);
            if (element.data('progressCircle')) {
                let _progressCircle = new ProgressCircle(this, options);
                return element.data('progressCircle');
            }
            $(this).append(
                '<div class="prog-circle">' +
                    '    <div class="percenttext"> </div>' +
                    '    <div class="slice">' +
                    '        <div class="bar"> </div>' +
                    '        <div class="fill"> </div>' +
                    '    </div>' +
                    '    <div class="after"> </div>' +
                    '</div>'
            );
            let progressCircle = new ProgressCircle(this, options);
            element.data('progressCircle', progressCircle);
            return undefined;
        });
    };

    jqueryFn.progressCircle.defaults = {
        nPercent: 50,
        showPercentText: true,
        circleSize: 100,
        thickness: 3,
        barOverride: true,
    };
})(jQuery, document, window);
